module.exports = "<div class=\"windows8\">\r\n  <div class=\"wBall\" id=\"wBall_1\">\r\n    <div class=\"wInnerBall\"></div>\r\n  </div>\r\n  <div class=\"wBall\" id=\"wBall_2\">\r\n    <div class=\"wInnerBall\"></div>\r\n  </div>\r\n  <div class=\"wBall\" id=\"wBall_3\">\r\n    <div class=\"wInnerBall\"></div>\r\n  </div>\r\n  <div class=\"wBall\" id=\"wBall_4\">\r\n    <div class=\"wInnerBall\"></div>\r\n  </div>\r\n  <div class=\"wBall\" id=\"wBall_5\">\r\n    <div class=\"wInnerBall\"></div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/loader/loader.component.html
// module id = ./src/app/common/loader/loader.component.html
// module chunks = main